var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 18.333a8.333 8.333 0 110-16.666 8.333 8.333 0 010 16.666zm0-1.666a6.667 6.667 0 100-13.334 6.667 6.667 0 000 13.334zM8.333 8.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM12.917 10a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM10 15c1.75 0 3.289-.898 4.182-2.259l-1.295-1.072A3.335 3.335 0 0110 13.333a3.344 3.344 0 01-2.876-1.666L5.83 12.741A5 5 0 0010 15z"
  })));
};

export default SvgSmile;